// extracted by mini-css-extract-plugin
module.exports = {"sort":"DT","selected":"ET","disabled":"FT"};